export const CATEGORY_MAINTAINABILITY = 'maintainability'
export const CATEGORY_PERFORMANCE = 'performance'
export const CATEGORY_SECURITY = 'security'
export const CATEGORY_INTRODUCE_BUGS = 'bugs'
export const CATEGORY_TESTS = 'testing'
export const IMPACT_HIGH = 'high'
export const IMPACT_MEDIUM = 'medium'
export const IMPACT_LOW = 'low'
